import React, { useState } from "react";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Box } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import PageLoader from "@jumbo/components/PageComponents/PageLoader";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import api from "../../../services/api";
import { getToken } from "../../../services/auth";
import Swal from "sweetalert2";

const schema = yup
  .object({
    centroCustos: yup.string().required("Centro de Custos é obrigatório")
  })
  .required();

export default function CreateCentroCustos(props) {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [centroCustos, setCentroCustos] = useState();
  const headers = { Authorization: "Bearer " + getToken() };

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const onChangeItem = props.onChangeItem;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCadastrar = () => {
    setIsLoading(true);
    try {
      api
        .post(
          "ponto/centro-custos",
          {
            nome: centroCustos,
            ativo: 1
          },
          { headers }
        )
        .then(res => {
          setIsLoading(false);
          Swal.fire({
            icon: "success",
            confirmButtonColor: "#3085d6",
            title: "Uhul!",
            text: "Centro de custo adicionado."
          });
          handleClose();
          onChangeItem({ nome: centroCustos });
        })
        .catch(err => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#3085D6",
            title: "Oops...",
            text: "Não conseguimos adicionar o centro de custos"
          });
        });
    } catch (err) {
      Swal.fire({
        icon: "error",
        confirmButtonColor: "#3085D6",
        title: "Oops...",
        text: "Não conseguimos conectar na api"
      });
    }
    setIsLoading(false);
    onChangeItem({ nome: centroCustos });
  };

  return (
    <Box>
      <Box align="right">
        <Button
          variant="contained"
          color="primary"
          onClick={handleClickOpen}
          title="Cadastrar Centro de Custos"
        >
          <AddIcon />
        </Button>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="centroCustos"
        fullWidth
      >
        <DialogTitle id="centroCustos">Cadastrar Centro de Custos</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            id="nome_centro_custos"
            label="Descrição"
            type="text"
            name="centroCustos"
            error={errors.centroCustos ? true : false}
            helperText={errors.centroCustos?.message}
            {...register("centroCustos", {
              required: true,
              onChange: e => setCentroCustos(e.target.value),
              shouldUnregister: true
            })}
          />
        </DialogContent>
        <DialogActions>
          {isLoading == true ? (
            <PageLoader />
          ) : (
            <div>
              <Button onClick={handleClose} color="secondary">
                Cancelar
              </Button>
              <Button onClick={handleSubmit(handleCadastrar)} color="primary">
                Salvar
              </Button>
            </div>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
}
